import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd9e9982"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-edit-form" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { class: "checkLabel" }

import { reactive, getCurrentInstance, computed } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { resolve } from "path";


export default /*#__PURE__*/_defineComponent({
  emits: ["confim", "close"],
  setup(__props, { expose, emit: emits }) {

const { proxy } = getCurrentInstance() as any;

const state = reactive({
  showDialog: false,
  title: "",
  activeName: "",
  status: false,
  userCount: 0,
  visionLevel: "",
  roleId: "",
  shopOptions: [{ label: "总部", value: "" }],
  visionLevelOptions: [] as any,
  loginPortItems: [] as any,
  tabItems: [] as any,
  form: {
    permissionGroupKeyList: [],
  } as any,
  ruleForm: {
    name: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
    roleLevelEnum: [{ required: true, message: "请选择角色", trigger: "blur" }],
    tenantAndShop: [{ required: true, message: "请选择租户门店", trigger: "blur" }],
    // shopId: [{ required: true, message: '请选择应用门店', trigger: "blur" }],
    visionLevel: [{ required: true, message: "请选择数据可见范围", trigger: "blur" }],
  },
  VisionLevelKindPocket: [],
  tenantAndShopOption: [],
});

const switchChange = () => {
  return new Promise((resolve) => {
    // 启用
    ElMessageBox.confirm(
      !state.status
        ? "此操作将启用本角色，启用后可配置给员工，是否继续？"
        : state.userCount
        ? `本角色目前有${state.userCount}个用户在使用，停用后相关用户将无法使用当前角色，是否继续？`
        : "此操作将停用本角色，停用后不可配置给员工，是否继续？",
      "提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    )
      .then(async () => {
        const openApi = `/ops/role/enable/${state.form.id}`;
        const closeApi = `/ops/role/disable/${state.form.id}`;
        const params = {
          ...state.form,
        };
        const api = state.status ? closeApi : openApi;
        const [res] = (await proxy.$api.post(api, params)) || [];
        if (res) {
          state.form = { ...res };
        }
        ElMessage({
          message: `已${state.status ? "停用" : "启用"}角色`,
          type: "success",
        });
        return resolve(true);
      })
      .catch(() => {
        return resolve(false);
      });
  });
};
const visionLevelChange = (val: any) => {
  if (state.form.shopId === "") {
    state.visionLevelOptions[1].disabled = true;
  } else {
    state.visionLevelOptions[1].disabled = false;
  }
};

// 切换角色等级
const onChangeRoleRank = (val: any) => {
  const visionLevelMap: any = {
    TENANT: "系统级",
    SHOP: "门店级",
    INDIVIDUAL: "个人级",
  };
  if (val === "TENANT") {
    state.tenantAndShopOption = proxy
      .pocket("TenantAll")
      .map((el) => ({ label: el.label, value: el.value }));
  }
  if (val === "SHOP") {
    state.tenantAndShopOption = proxy.pocket("TenantAll");
  }
  state.visionLevelOptions = state.VisionLevelKindPocket.map((item: any) => {
    if (val === "TENANT") {
      return {
        label: visionLevelMap[item.label],
        value: item.value,
        disabled: item.value === 'SHOP' ? true : false,
      };
    } else if (val === "SHOP") {
      return {
        label: visionLevelMap[item.label],
        value: item.value,
        disabled: item.value === "TENANT" ? true : false,
      };
    } else {
      return {
        label: val[item.label],
        value: item.value,
        disabled: item.value === "INDIVIDUAL" ? false : true,
      };
    }
  });
};

// 切换租户门店
const onChangeTenantAndShop = async (value) => {
  let tenantId = value[0];
  const treeApi = "/ops/permission-group/tree?tenantId=" + tenantId;
  const [tree] = (await proxy.$api.get(treeApi)) || [];
  if (tree) {
    state.loginPortItems = tree.systemAllowLoginList;
    state.tabItems = tree.applicationList;
    state.activeName = tree.applicationList[0].description;
  }
};

const shopIdChange = (val: any) => {
  if (val === "") {
    state.visionLevelOptions[0].disabled = false;
    state.visionLevelOptions[1].disabled = true;
    state.form.visionLevel = "TENANT";
  } else {
    state.visionLevelOptions[0].disabled = true;
    state.visionLevelOptions[1].disabled = false;
    if (state.form.visionLevel === "TENANT") {
      state.form.visionLevel = "SHOP";
    }
  }
};



const confimForm = async () => {
  const { permissionGroupKeyList } = state.form;
  const loginPortKey = state.loginPortItems.map((item: any) => item.key);
  let setProt = false; // 是否设置了端口权限
  if (permissionGroupKeyList.length > 0) {
    permissionGroupKeyList.forEach((item: any) => {
      if (loginPortKey.includes(item)) {
        setProt = true;
      }
    });
  }

  if (!setProt) {
    ElMessageBox.alert("请选择端口权限", "警告", {
      confirmButtonText: "确定",
      type: "warning",
    });
    return;
  }
  const params = {
    ...state.form,
  };
  params.tenantId = state.form.tenantAndShop[0];
  params.shopId = state.form.tenantAndShop[1];
  delete params.tenantAndShop;
  const api = "/ops/role/save";
  const [res] = (await proxy.$api.post(api, params)) || [];
  if (res) {
    state.showDialog = false;
    emits("confim");
    window.location.reload();
  }
};

const load = async () => {
  const loadApi = `/ops/role/edit/${state.form.id}`;
  const [res] = (await proxy.$api.get(loadApi)) || [];
  if (res) {
    state.form = {
      ...res,
      shopId: res.shopId ? res.shopId : "",
      tenantAndShop: [res.tenantId, res.shopId].filter((el) => el),
    };
    state.status = res.disabled ? false : true;
  }
  const visionLevelMap: any = {
    TENANT: "系统级",
    SHOP: "门店级",
    INDIVIDUAL: "个人级",
  };

  // 获取当前登录账号角色权限
  const currentRole = (proxy?.obtainAccount() as any)?.currentRole;
  state.roleId = currentRole?.id;
  const visionLevel = currentRole?.visionLevel;

  // 根据登录的角色权限 控制门店与权限级是否可选
  state.visionLevelOptions = state.VisionLevelKindPocket.map((item: any) => {
    if (visionLevel === "TENANT") {
      return {
        label: visionLevelMap[item.label],
        value: item.value,
        disabled: false,
      };
    } else if (visionLevel === "SHOP") {
      return {
        label: visionLevelMap[item.label],
        value: item.value,
        disabled: item.value === "TENANT" ? true : false,
      };
    } else {
      return {
        label: visionLevelMap[item.label],
        value: item.value,
        disabled: item.value === "INDIVIDUAL" ? false : true,
      };
    }
  });

  // 获取门店选项
  const shopOptions = proxy?.pocket("ShopList");
  const curUser = computed(() => {
    return proxy.obtainAccount();
  });
  state.shopOptions =
    visionLevel === "TENANT" ? [...state.shopOptions, ...shopOptions] : shopOptions;
  // 新建时 初始化赋值
  if (!state.form.id) {
    if (visionLevel === "TENANT") {
      state.form.visionLevel = visionLevel;
      state.form.shopId = "";
      state.visionLevelOptions[1].disabled = true;
    } else if (visionLevel === "SHOP") {
      state.form.visionLevel = visionLevel;
      state.visionLevelOptions[0].disabled = true;
      state.shopOptions = state.shopOptions.filter((item) => {
        return item.value === curUser.value.currentRole?.shopId;
      });
      state.form.shopId = state.shopOptions[0].value;
    }
  } else {
    if (state.form.shopId === "") {
      state.visionLevelOptions[1].disabled = true;
    } else {
      state.visionLevelOptions[0].disabled = true;
    }
  }

  if (state.form.id) {
    if (res.roleLevelEnum === "TENANT") {
      state.tenantAndShopOption = proxy
        .pocket("TenantAll")
        .map((el) => ({ label: el.label, value: el.value }));
    }
    if (res.roleLevelEnum === "SHOP") {
      state.tenantAndShopOption = proxy.pocket("TenantAll");
    }

    const treeApi = "/ops/permission-group/tree?tenantId=" + res.tenantId;
    const [tree] = (await proxy.$api.get(treeApi)) || [];
    if (tree) {
      state.loginPortItems = tree.systemAllowLoginList;
      state.tabItems = tree.applicationList;
      state.activeName = tree.applicationList[0].description;
    }
  }
};

const active = (res: any) => {
  state.form = {
    permissionGroupKeyList: [],
  };
  state.showDialog = true;
  state.title = res.id ? "编辑角色" : "新建角色";
  state.shopOptions = [{ label: "总部", value: "" }];
  if (res.id) {
    state.form.id = res.id;
    state.userCount = res.userCount;
    // state.status = res.disabled ? false : true
  }
  state.VisionLevelKindPocket = res.VisionLevelKindPocket;

  load();
};
expose({
  active,
});

return (_ctx: any,_cache: any) => {
  const _component_MasFormGroupTitle = _resolveComponent("MasFormGroupTitle")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_mas_form_main = _resolveComponent("mas-form-main")!
  const _component_mas_modal = _resolveComponent("mas-modal")!

  return (_openBlock(), _createBlock(_component_mas_modal, {
    visible: _unref(state).showDialog,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).showDialog) = $event)),
    customFooterBtns: "",
    closeIcon: "",
    width: "800px",
    title: _unref(state).title
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_mas_form_main, {
          form: _unref(state).form,
          ruleForm: _unref(state).ruleForm,
          labelWidth: "120px",
          defaultFormFooterButton: ['confirm', 'cancel'],
          onConfim: confimForm,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (_unref(state).showDialog = false))
        }, {
          content: _withCtx((slotProps) => [
            _createVNode(_component_MasFormGroupTitle, { title: "基本信息" }),
            (slotProps.content.id)
              ? (_openBlock(), _createBlock(_component_el_switch, {
                  key: 0,
                  modelValue: _unref(state).status,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).status) = $event)),
                  "before-change": switchChange,
                  style: {"float":"right","margin-right":"20px"},
                  disabled: slotProps.content.id === _unref(state).roleId
                }, null, 8, ["modelValue", "disabled"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "角色名称",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: slotProps.content.name,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.content.name) = $event),
                  placeholder: "请输入角色名称",
                  maxlength: "30",
                  "show-word-limit": "",
                  style: {"width":"500px"}
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_form_item, {
              label: "角色说明",
              prop: "description"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: slotProps.content.description,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.content.description) = $event),
                  placeholder: "输入0-30个字符",
                  maxlength: "30",
                  "show-word-limit": "",
                  style: {"width":"500px"}
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_form_item, {
              label: "角色等级",
              prop: "roleLevelEnum",
              class: "is-required"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: slotProps.content.roleLevelEnum,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.content.roleLevelEnum) = $event),
                  clearable: "",
                  onChange: onChangeRoleRank
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pocket('roleLevel'), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.label,
                        value: item.value,
                        label: item.label
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_form_item, {
              label: "租户门店",
              prop: "tenantAndShop",
              class: "is-required"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  modelValue: slotProps.content.tenantAndShop,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.content.tenantAndShop) = $event),
                  placeholder: "请选择租户门店",
                  props: { checkStrictly: _unref(state).form.roleLevel === 'TENANT' },
                  options: _unref(state).tenantAndShopOption,
                  filterable: "",
                  clearable: "",
                  onChange: onChangeTenantAndShop
                }, null, 8, ["modelValue", "onUpdate:modelValue", "props", "options"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_form_item, {
              label: "可见数据范围",
              prop: "visionLevel"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: slotProps.content.visionLevel,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.content.visionLevel) = $event),
                  onChange: visionLevelChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).visionLevelOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_radio, {
                        key: item.label,
                        label: item.value,
                        disabled: item.disabled
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "disabled"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            (_unref(state).loginPortItems?.length)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "登录端口",
                  class: "is-required"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox_group, {
                      modelValue: slotProps.content.permissionGroupKeyList,
                      "onUpdate:modelValue": ($event: any) => ((slotProps.content.permissionGroupKeyList) = $event)
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).loginPortItems, (item) => {
                          return (_openBlock(), _createBlock(_component_el_checkbox, {
                            key: item.key,
                            label: item.key
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.description), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (slotProps.content?.permissionGroupKeyList?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_MasFormGroupTitle, { title: "功能权限" }),
                  _createVNode(_component_el_tabs, {
                    modelValue: _unref(state).activeName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).activeName) = $event)),
                    class: "demo-tabs"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).tabItems, (item) => {
                        return (_openBlock(), _createBlock(_component_el_tab_pane, {
                          key: item.key,
                          label: item.description,
                          name: item.description
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_checkbox_group, {
                              modelValue: slotProps.content.permissionGroupKeyList,
                              "onUpdate:modelValue": ($event: any) => ((slotProps.content.permissionGroupKeyList) = $event)
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.permissionGroupCatalogList, (value) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: value.key
                                  }, [
                                    _createElementVNode("div", _hoisted_3, _toDisplayString(value.description), 1),
                                    _createVNode(_component_el_form_item, { "label-width": "50px" }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.permissionGroupBOList, (check) => {
                                          return (_openBlock(), _createBlock(_component_el_checkbox, {
                                            key: check.key,
                                            label: check.key
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(check.description), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["label"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["label", "name"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["form", "ruleForm"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})